/**
 * @generated SignedSource<<d863531606d13adc946837d663893e86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trendOfferSection_TrendOfferFragment$data = {
  readonly aboutOffersHeadingAndDescription: {
    readonly description: string;
    readonly heading: string;
  };
  readonly " $fragmentType": "trendOfferSection_TrendOfferFragment";
};
export type trendOfferSection_TrendOfferFragment$key = {
  readonly " $data"?: trendOfferSection_TrendOfferFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"trendOfferSection_TrendOfferFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "trendOfferSection_TrendOfferFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HeadingAndDescription",
      "kind": "LinkedField",
      "name": "aboutOffersHeadingAndDescription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "heading",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Trend",
  "abstractKey": null
};

(node as any).hash = "7abba4a80f98c92a21b60941f62be7dc";

export default node;
